import React, { useContext, useEffect, useState } from "react";
import "./Appearance.css";
import { Button } from "antd";
import { RootContext } from "../../RootContextProvider";
import PreviewPredefined from "./PreviewPredefined";
import PreviewCustom from "./PreviewCustom";
import ReactDevicePreview from "react-device-preview";
import fontColorContrast from "font-color-contrast";
import "./Preview.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ModalLinkCopied from "../ModalLinkCopied/ModalLinkCopied";
import { EyeOutlined } from "@ant-design/icons";

const PagePreview = () => {
  const { pages, links } = useContext(RootContext);
  const [fontColor, setFontColor] = useState();
  const [link, setLink] = useState();
  const [copied, setCopied] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const getFontColor = () => {
      if (pages && pages.HasCustomTheme) {
        setFontColor(fontColorContrast(pages.ThemeColor));
        console.log(fontColorContrast(pages.ThemeColor));
      }
    };
    getFontColor();
    // eslint-disable-next-line
  }, [pages ? pages.ThemeColor : ""]);

  useEffect(() => {
    const setDefaultLink = () => {
      if (pages) {
        setLink("linksight.me/" + pages.PageName);
      }
    };
    setDefaultLink();
    // eslint-disable-next-line
  }, []);

  const handleClickCopy = () => {
    setCopied(true);
    setModalIsOpen(true);
  };

  return (
    <div className="appearance-preview">
      {link ? (
        <>
          <div className="linksight-link">
            <div className="link-part">
              <span>{link}</span>
            </div>
            <CopyToClipboard text={link} onCopy={() => handleClickCopy()}>
              <Button
                type="secondary"
                style={{
                  width: "fit-content",
                  height: "40px",
                  borderRadius: "0px 3px 3px 0px",
                }}
              >
                {!copied ? "Copier" : "Copié !"}
              </Button>
            </CopyToClipboard>
          </div>
          <div style={{ margin: "15px auto", textAlign: "center" }}>
            <a
              href={`https://${link}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#4d61fc" }}
            >
              <EyeOutlined style={{ marginRight: "5px" }} />
              Voir ma page
            </a>
          </div>
        </>
      ) : (
        ""
      )}
      {pages ? (
        <div className="iphone-container">
          <ReactDevicePreview device="iphonex" color="black" scale="0.6">
            {pages.HasCustomTheme ? (
              <PreviewCustom
                themeFontColor={fontColor}
                pageDetails={pages}
                links={links}
              />
            ) : (
              <PreviewPredefined pageDetails={pages} links={links} />
            )}
          </ReactDevicePreview>
        </div>
      ) : (
        ""
      )}
      <ModalLinkCopied
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
      />
    </div>
  );
};

export default PagePreview;
